import { Star, StarBorderOutlined } from '@mui/icons-material';
import React from 'react';

interface FavoriteStarIconProps {
  isActive?: boolean;
}

export const FavoriteStarIcon = (props: FavoriteStarIconProps) => {
  const { isActive = false } = props;

  if (isActive) return <Star style={{ fill: '#FFCA28' }} />;
  return <StarBorderOutlined style={{ fill: '#FFCA28' }} />;
};
